import { colors } from '../../../config/theme'

export default {
  generalError: {
    height: 20,
    textAlign: 'center',
    textTransform: 'capitalize',
    color: colors.error
  },
  field: {
    minWidth: '330px'
  },
  divider: {
    height: 10
  }
}


// WEBPACK FOOTER //
// ./src/containers/ResetPassword/ResetPasswordFrom/style.js